import React, { useEffect, useState } from 'react'
import { Grid } from '@mui/material'


function CommonEditableTable({ rateCardData, onSubmitData, tripType }) {
  let initialEmployeeData = []
  let newRateCardArray = []
  if(tripType?.id == 1){
    initialEmployeeData = rateCardData?.length > 0 ? rateCardData?.map(item => ({
      employeeId: item.id,
      baseRate: item?.baseRate,
      currentRate: item?.currentRate,
      waitingChargesPerHr: item?.waitingChargesPerHr
    })) : [{employeeId: null,
      baseRate: 0,
      currentRate: 0,
      waitingChargesPerHr: 0}]
  }else if (tripType?.id == 3){ 
    //merged two array oject key value(logic)
    newRateCardArray = rateCardData?.extraPerHrCharges?.map((item, i) => Object.assign({}, item, rateCardData?.extraPerKmCharges[i]))
    initialEmployeeData = newRateCardArray?.length > 0 ? newRateCardArray?.map(item => ({
      employeeId: item.id,
      extraKMrate: item?.basePerKmCharge,
      extraHRrate: item?.basePerHrCharge,
      currentKMrate: item?.currentPerKmCharge,
      currentHRrate: item?.currentPerHrCharge,
    })) : [{
      employeeId: null,
      extraKMrate: 0,
      extraHRrate: 0,
      currentKMrate: 0,
      currentHRrate: 0,
    }]
  }else{
    initialEmployeeData = (rateCardData && rateCardData?.length > 0) ? rateCardData?.map(item => ({
      employeeId: item.id,
      maxTime: item?.maxTime,
      maxDistance: item?.maxDistance,
      baseRate: item?.baseRate,
      currentRate: item?.currentRate,
    })) : []
  };

  const [employeeData, setEmployeeData] = useState(initialEmployeeData);
  const [slabBtn, setSlabBtn] = useState(true);

  useEffect(() => {
    setEmployeeData(initialEmployeeData)
  }, [rateCardData])

  const slabArray = employeeData.map((item) => {
    return {maxTime:parseFloat(item?.maxTime), maxDistance:parseFloat(item?.maxDistance)}
  })
  const baseRateArray = employeeData.map((item) => item.baseRate);
  const currentRateArray = employeeData.map((item) => item.currentRate);

  const onSubmit = () => {
    setSlabBtn(true)
    let filterData = {}
    if(tripType?.id == 2){
      filterData = {
        slab: (slabArray),
        baseRate: baseRateArray,
        currentRate: currentRateArray
      }
    }else if(tripType?.id == 1){
      filterData = {
        baseRate: employeeData[0]?.baseRate,
        currentRate: employeeData[0]?.currentRate,
        waitingChargesPerHr: employeeData[0]?.waitingChargesPerHr
      }
    }else{
      filterData = {
        basePerKmCharge: employeeData[0]?.extraKMrate,
        basePerHrCharge: employeeData[0]?.extraHRrate
      }
    }
    onSubmitData(filterData)
  }



  const onChange = (e, employeeId, index) => {
    setSlabBtn(false)
    const { name, value } = e.target
    let editData = [...employeeData]
    if(e.target.value > 0 || e.target.value === 0){
      editData[index] = { ...editData[index], [name]: value }
    }else if(e.target.value < 0){
      editData[index] = { ...editData[index], [name]: 0 }
    }else{
      editData[index] = { ...editData[index], [name]: value }
    }
    setEmployeeData(editData)
  }

  const addRow = () => {
    setSlabBtn(false)
    let newRow = {}
    if(tripType?.id == 3){

    }else{
      newRow = {
        maxTime: 0,
        maxDistance: 0,
        baseRate: 0,
        currentRate: 'NA',
      }
    }


    setEmployeeData([...employeeData, newRow]);
  };

  return (
    <div className="paddingInline40">
      <table className='tableMain'>
        <thead>
          {tripType?.id === 2 &&<tr className='tableRow'>
            <th>Slab</th>
            <th>Base Rate</th>
            <th>Current Rate</th>
          </tr>}
          {tripType?.id === 3 &&<tr className='tableRow'>
            <th>Extra KM Base rate</th>
            <th>Extra HR Base rate</th>
            <th>Extra KM Current Rate</th>
            <th>Extra HR Current Rate</th>
          </tr>}
          {tripType?.id === 1 && <tr className='tableRow'>
            <th>Base Rate</th>
            <th>Current Rate</th>
            <th>Waiting rate</th>
          </tr>}
        </thead>
        <tbody>
          {employeeData?.map(({ employeeId, slab, maxTime, maxDistance, baseRate,currentRate,waitingChargesPerHr, FuleRate, extraKMrate, extraHRrate, currentHRrate, currentKMrate }, index) => (
            <tr key={employeeId} className='tableRow'>
              {tripType?.id === 2 && <td className='tableDis'>
                <Grid container direction='row' justifyContent='center' alignContent='center' alignItems='center' >
                  <Grid item xs={2} display='flex' alignItems='center' justifyContent='center'>
                    <input
                      name="maxTime"
                      value={maxTime}
                      type="number"
                      onChange={(e) => onChange(e, employeeId, index)}
                      placeholder="Add Hr"
                      className='maxTime'
                    />Hr</Grid>
                      <span>{"-"}</span>
                  <Grid item xs={2} display='flex' alignItems='center' justifyContent='center'>
                    <input
                      name="maxDistance"
                      value={maxDistance}
                      type="number"
                      onChange={(e) => onChange(e, employeeId, index)}
                      placeholder="Add KM"
                      className='maxTime'
                    />KM</Grid>
                </Grid>
              </td>}
              {tripType?.id === 3 && <td className='tableDis'>
                ₹<input
                  name="extraKMrate"
                  type="number"
                  value={extraKMrate}
                  onChange={(e) => onChange(e, employeeId, index)}
                  placeholder="Type Position"
                  className='baseType'
                />
              </td>}
              {tripType?.id === 3 && <td className='tableDis'>
                ₹<input
                  name="extraHRrate"
                  type="number"
                  value={extraHRrate}
                  onChange={(e) => onChange(e, employeeId, index)}
                  placeholder="Type Position"
                  className='baseType'
                />
              </td>}
              {tripType?.id === 3 && <td className='tableDis'>
                ₹<input
                  name="currentKMrate"
                  type="number"
                  value={currentKMrate}
                  disabled={true}
                  onChange={(e) => onChange(e, employeeId, index)}
                  placeholder="Type Position"
                  className='baseType'
                />
              </td>}
              {tripType?.id === 3 && <td className='tableDis'>
                ₹<input
                  name="currentHRrate"
                  type="number"
                  value={currentHRrate}
                  disabled={true}
                  onChange={(e) => onChange(e, employeeId, index)}
                  placeholder="Type Position"
                  className='baseType'
                />
              </td>}
             {(tripType?.id === 2 || tripType?.id === 1) && <td className='tableDis'>
                ₹<input
                  name="baseRate"
                  value={baseRate}
                  type="number"
                  onChange={(e) => onChange(e, employeeId, index)}
                  placeholder="Type Base"
                  className='baseType'
                />
              </td>}
              {(tripType?.id === 2 || tripType?.id === 1) && <td className='tableDis'>
                ₹<input
                  name="currentRate"
                  type="number"
                  value={currentRate}
                  disabled={true}
                  onChange={(e) => onChange(e, employeeId, index)}
                  placeholder="Type Position"
                  className='baseType'
                />
              </td>}
              {tripType?.id === 1 && <td className='tableDis'>
                ₹<input
                  name="waitingChargesPerHr"
                  type="number"
                  value={waitingChargesPerHr}
                  onChange={(e) => onChange(e, employeeId, index)}
                  placeholder="Type Position"
                  className='baseType'
                />
              </td>}
            </tr>
          ))}
        </tbody>
      </table>
      <Grid container direction='row' justifyContent='flex-end' alignItems='center'>
        <Grid item xs={12} className='flexend'>
          {(tripType?.id === 2) && <button onClick={addRow} className='slabBtn'>Slab +</button>}
          <button disabled={slabBtn} onClick={() => { onSubmit() }} className={`${slabBtn ? 'btnDisable' : 'btnSubvendor'} margin10`}>Submit</button>
        </Grid>
      </Grid>
    </div>
  )
}

export default CommonEditableTable